import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
/* actions */
import { getAllIVRsConfig, editIVRsConfig } from '../../redux/actions/ivrs';
import { getAllDevices } from '../../redux/actions/devices';
import ErrorMsgField from '../../components/ErrorMsgField';
/* components */
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
import MultiSelect from '../../components/MultiSelect';
/* form-validation */
import schema from '../../form-validation/ivrConfig';

function Config () {
  const sortable = (a, b) => {
    return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
  };
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema
  });
  const ivrs = useSelector(state => state.ivrs);
  const devices = useSelector(state => state.devices.data);
  const dispatch = useDispatch();
  const INITIAL_VALUES = {
    voipdeviceindex: 0,
    password: '',
    sipserver: '',
    sipport: '',
    users: []
  };
  const [data, setData] = useState(INITIAL_VALUES);
  const submitButton = useRef();
  const [selectedOptions, setSelectedOptions] = useState({ users: [] });
  const [usrs, setUsrs] = useState([]);

  useEffect(() => {
    dispatch(getAllDevices());
    dispatch(getAllIVRsConfig());
  }, [dispatch]);

  useEffect(() => {
    const newData = {
      ...ivrs.config
    };
    setData(newData);
  }, [ivrs.config]);

  useEffect(() => {
    if (devices.length) {
      const usrs = devices
        .filter(device => device.type === 'E')
        .map(ext => ({
          value: ext.number,
          text: `${ext.number} | Dpto: ${ext.department.name}`
        }))
        .sort(sortable);

      const users = usrs.filter(usr => ivrs.config.users.includes(usr.value));

      setSelectedOptions({ users });
      setUsrs([...usrs]);
    }
  }, [devices, setUsrs, ivrs.config.users]);

  const submit = () => {
    dispatch(editIVRsConfig(data, submitButton.current));
  };

  const handleChange = evt => {
    evt.preventDefault();
    if (evt.target.getAttribute('number') === 'on') {
      if (evt.target.value.match(/^\d+$/) || evt.target.value === '') {
        setData({
          ...data,
          [evt.target.name]: evt.target.value
        });
      } else {
        evt.target.value = data[evt.target.name];
      }
    } else {
      const isCheckbox = evt.target.type === 'checkbox';
      setData({
        ...data,
        [evt.target.name]: isCheckbox ? evt.target.checked : evt.target.value
      });
    }
  };

  const handleMultiDeselect = (deselecteds, nameField) => {
    const options = selectedOptions[nameField].slice();
    deselecteds.forEach(option => options.splice(options.indexOf(option), 1));
    setSelectedOptions({ ...selectedOptions, [nameField]: options });
    const values = options.map(opt => opt.value);
    setData({ ...data, [nameField]: values });
  };

  const handleMultiSelect = (selecteds, nameField) => {
    const options = selecteds.slice();
    options.sort(sortable);
    setSelectedOptions({ ...selectedOptions, [nameField]: options });
    const values = options.map(opt => opt.value);
    setData({ ...data, [nameField]: values });
  };

  return (
    <div className="container-fluid">
      {ivrs.editSuccess && (
        <AlertMsg type="success" msg="Configuração atualizada com sucesso" />
      )}
      {ivrs.editError && (
        <AlertMsg type="danger" msg="Falha durante configuração URA" />
      )}
      {!ivrs.editSuccess && !ivrs.editError && (
        <AlertMsg type="info" msg="Área configuração URA" />
      )}
      <FormHeader title="URA - Configurações" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="sipserver">
                IP Servidor SIP<span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="sipserver"
                name="sipserver"
                autoComplete="off"
                onChange={handleChange}
                defaultValue={data.sipserver || ''}
                ref={register}
              />
              {errors.sipserver && errors.sipserver.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.sipserver && errors.sipserver.type === 'ipV4' && (
                <ErrorMsgField type="ipV4" />
              )}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="sipport">
                Porta Servidor SIP<span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="sipport"
                name="sipport"
                autoComplete="off"
                number="on"
                onChange={handleChange}
                defaultValue={data.sipport || ''}
                ref={register}
              />
              {errors.sipport && errors.sipport.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
              {errors.sipport && errors.sipport.type === 'max' && (
                <ErrorMsgField type="max" />
              )}
              {errors.sipport && errors.sipport.type === 'typeError' && (
                <ErrorMsgField type="typeError" />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="password">
                Senha Ramais SIP<span className="field-required">*</span>
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                name="password"
                autoComplete="new-password"
                onChange={handleChange}
                defaultValue={data.password}
                ref={register}
              />
              {errors.password && errors.password.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="voipdeviceindex">
                Voip Device Index<span className="field-required">*</span>
              </label>
              <select
                className="form-control"
                id="voipdeviceindex"
                name="voipdeviceindex"
                onChange={handleChange}
                value={data.voipdeviceindex}
                ref={register}
              >
                {[...Array(10)].map((_, position) => {
                  return (
                    <option key={position} value={position}>
                      {position}
                    </option>
                  );
                })}
              </select>
              {errors.voipdeviceindex &&
                errors.voipdeviceindex.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
        </div>
        <MultiSelect
          avaliableOptions={usrs}
          selectedOptions={selectedOptions.users}
          handleMultiDeselect={options => handleMultiDeselect(options, 'users')}
          handleMultiSelect={options => handleMultiSelect(options, 'users')}
          valueProp="value"
          textProp="text"
          title="Ramais"
          fieldRequired={true}
          name="users"
          ref={register}
          error={!!errors.users}
        />
        <FormFooter hideBackButton={true} reference={submitButton} />
      </form>
    </div>
  );
}

export default Config;
